
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/popup/annual-upgrade",
      function () {
        return require("private-next-pages/popup/annual-upgrade.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/popup/annual-upgrade"])
      });
    }
  